import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  countPerPage: 0,
  lastDataChunk: [],
  page: 1,
  widgets: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
